import {useAtom, useAtomValue} from 'jotai';
import {atomWithStorage, createJSONStorage} from 'jotai/utils';
import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import {
  ECollapse,
  ESmallButton,
  EUndecoratedButton,
} from 'webapp-lib/Components';

import {userState} from '_/state/user';

type CollapseStore = {
  [key: string]: boolean;
};

const savedCollapseState = atomWithStorage<CollapseStore>(
  'esavedcollapse',
  {},
  createJSONStorage(),
  {getOnInit: true}
);

export const ESavedCollapse = ({
  viewId,
  children,
  displayUndecoratedButton,
  testId,
}: {
  viewId: string;
  children: React.ReactElement;
  displayUndecoratedButton?: boolean;
  testId?: string;
}): React.ReactElement => {
  const {t} = useTranslation('common');
  const user = useAtomValue(userState);
  const [collapseState, setCollapseState] = useAtom(savedCollapseState);
  const storeId = `${user.userId}_${viewId}`;

  const isOpen = collapseState[storeId] || false;

  const handleButtonClick = useCallback(() => {
    setCollapseState({...collapseState, [storeId]: !isOpen});
  }, [collapseState, isOpen, setCollapseState, storeId]);

  return (
    <>
      {displayUndecoratedButton ? (
        <EUndecoratedButton
          data-testid={
            testId ? `EUndecoratedButton-ESavedCollapse-${testId}` : undefined
          }
          onClick={handleButtonClick}
        >
          {isOpen ? t('actions.showLess') : t('actions.showMore')}
        </EUndecoratedButton>
      ) : (
        <ESmallButton
          testId={testId ? `ESavedCollapse-${testId}` : undefined}
          onClick={handleButtonClick}
        >
          {isOpen ? t('actions.showLess') : t('actions.showMore')}
        </ESmallButton>
      )}
      <ECollapse in={isOpen} mountOnEnter unmountOnExit>
        {children}
      </ECollapse>
    </>
  );
};
